import * as React from 'react';

interface SearchIconProps {
  ariaName?: string;
}

export const Search: React.VFC<SearchIconProps> = ({ ariaName }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8495 8.42476C14.8495 11.9731 11.9731 14.8495 8.42476 14.8495C4.87646 14.8495 2 11.9731 2 8.42476C2 4.87646 4.87646 2 8.42476 2C11.9731 2 14.8495 4.87646 14.8495 8.42476ZM13.6329 15.0473C12.1996 16.1761 10.3908 16.8495 8.42476 16.8495C3.77189 16.8495 0 13.0776 0 8.42476C0 3.77189 3.77189 0 8.42476 0C13.0776 0 16.8495 3.77189 16.8495 8.42476C16.8495 10.3909 16.176 12.1997 15.0472 13.6331L19.7071 18.293L18.2929 19.7072L13.6329 15.0473Z"
        fill="black"
      />
    </svg>
  );
};
